import { ISubscription } from "sharedFeatures/sharedServices/Responses/Subscription/ISubscription";

export class Subscription implements ISubscription{
    Address1: string = '';
    Address2: string = '';
    AutoRenew: boolean = false;
    BillingPeriod: string = '';
    City: string = '';
    CurrencyCode: string = '';
    ExpirationDateString: string = '';
    ExpirationDate: string = '';
    Fee: string = '';
    PaymentMethod: string = '';
    ProductId: string = '';
    ProductVersion: string = '';
    ProductQuantity: number = 0;
    Renewal: string = '';
    SubscriptionStatus: string = '';
    Zip: string = '';
    StartDate: string = '';
    SubscriptionReference: string = '';
    SubscriptionEnabled: boolean = false;
    IsSubscriptionDowngradeActive: boolean = false;
    DowngradeDate: string = '';
    DowngradePriceOption1: string = '';
    DowngradePriceOption2: string = '';
    LicenseType: string = '';
    LicensesAssigned: string = '';
    PriceOptionCodes: Array<string> = [];
    AdditionalLicenses: number = 0;
    LicenseCompanies: Array<number> = [];
    IsExpired: boolean = false;
    LicenseId: number = 0;
}
